import {
	lazy,
} from 'react';
import {
	PATHS,
} from '@routes/paths';

// LAZY LOADING
const PageOfferEntry = lazy(() =>
	import('@layouts/Pages/PageOfferEntry').then((module) => ({
		default: module.PageOfferEntry,
	})),
);
const Location = lazy(() =>
	import('@layouts/Pages/PageOfferEntry/location').then((module) => ({
		default: module.Location,
	})),
);
const Contacts = lazy(() =>
	import('@layouts/Pages/PageOfferEntry/contacts').then((module) => ({
		default: module.Contacts,
	})),
);
const Infos = lazy(() =>
	import('@layouts/Pages/PageOfferEntry/infos').then((module) => ({
		default: module.Infos,
	})),
);
const Lots = lazy(() =>
	import('@layouts/Pages/PageOfferEntry/lots').then((module) => ({
		default: module.Lots,
	})),
);
const Media = lazy(() =>
	import('@layouts/Pages/PageOfferEntry/media').then((module) => ({
		default: module.Media,
	})),
);
const Services = lazy(() =>
	import('@layouts/Pages/PageOfferEntry/services').then((module) => ({
		default: module.Services,
	})),
);
const Summary = lazy(() =>
	import('@layouts/Pages/PageOfferEntry/summary').then((module) => ({
		default: module.Summary,
	})),
);
const Terms = lazy(() =>
	import('@layouts/Pages/PageOfferEntry/terms').then((module) => ({
		default: module.Terms,
	})),
);

export const OFFER_ENTRY_ROOT_ROUTES = [
	{
		element: <PageOfferEntry />,
		path: PATHS.OFFERS.EDIT._ROOT,
	},
];

export const OFFER_ENTRY_LOCATION_CREATE_ROUTES = [
	{
		element: <Location />,
		path: PATHS.OFFERS.NEW,
	},
];

export const OFFER_ENTRY_LOCATION_EDIT_ROUTES = [
	{
		element: <Location />,
		path: PATHS.OFFERS.EDIT.LOCATION,
	},
];

export const OFFER_ENTRY_LOCATION_ROUTES = [
	...OFFER_ENTRY_LOCATION_CREATE_ROUTES,
	{
		element: <Location />,
		path: PATHS.OFFERS.EDIT.LOCATION,
	},
];

export const OFFER_ENTRY_INFOS_ROUTES = [
	{
		element: <Infos />,
		path: PATHS.OFFERS.EDIT.INFOS,
	},
];

export const OFFER_ENTRY_CONTACTS_ROUTES = [
	{
		element: <Contacts />,
		path: PATHS.OFFERS.EDIT.CONTACTS,
	},
];

export const OFFER_ENTRY_LOTS_ROUTES = [
	{
		element: <Lots />,
		path: PATHS.OFFERS.EDIT.LOTS,
	},
];

export const OFFER_ENTRY_MEDIA_ROUTES = [
	{
		element: <Media />,
		path: PATHS.OFFERS.EDIT.MEDIA,
	},
];

export const OFFER_ENTRY_SERVICES_ROUTES = [
	{
		element: <Services />,
		path: PATHS.OFFERS.EDIT.SERVICES,
	},
];

export const OFFER_ENTRY_TERMS_ROUTES = [
	{
		element: <Terms />,
		path: PATHS.OFFERS.EDIT.TERMS,
	},
];

export const OFFER_ENTRY_SUMMARY_ROUTES = [
	{
		element: <Summary />,
		path: PATHS.OFFERS.EDIT.SUMMARY,
	},
];

export const OFFER_ENTRY_ROUTES = [
	...OFFER_ENTRY_ROOT_ROUTES,
	...OFFER_ENTRY_LOCATION_ROUTES,
	...OFFER_ENTRY_INFOS_ROUTES,
	...OFFER_ENTRY_CONTACTS_ROUTES,
	...OFFER_ENTRY_LOTS_ROUTES,
	...OFFER_ENTRY_MEDIA_ROUTES,
	...OFFER_ENTRY_SERVICES_ROUTES,
	...OFFER_ENTRY_TERMS_ROUTES,
	...OFFER_ENTRY_SUMMARY_ROUTES,
];
